import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import $ from 'jquery';
import { API_DOMAIN } from './globals'; // Import the global domain name

function AB2() {

    const [UserType, setUserType] = useState("");
    const [UserName, setUserName] = useState("");

    const [Team1Amt, setTeam1Amt] = useState("");
    const [Team2Amt, setTeam2Amt] = useState("");

    const [AB2Bets, setAB2Bets] = useState([]);
    const [LastResult, setLastResult] = useState([]);
    const [BetChk, setBetChk] = useState(true);

    const handleCancelClick = () => {
        document.getElementById("betSlipBoxSession").style.display = "none";
        document.getElementById("betSlipBoxSessionMob").style.display = "none";
    };

    const handlePlaceBet = () => {
        PlaceAB2Bet();
    };

    function getAB2Result() {
        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        const params = { ut: param1, un: param2 };

        const queryString = new URLSearchParams(params).toString();
        const url = `${API_DOMAIN}/api/Client/getAB2Result.php?${queryString}`;

        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if(data.Status=="Error") {
                    sessionStorage.setItem("LogoutMsg",data.Message)
                    window.location = '/';
                } else {
                    setLastResult(data.data);
                    var UsedCoins = data.data[0].UsedCoins;
                    $("#TotalCoins").html(data.data[0].TotalCoins - data.data[0].UsedCoins);
                    $("#UsedCoins").html(UsedCoins);
                    $("#TotalCoinsMob").html(data.data[0].TotalCoins-data.data[0].UsedCoins);
                    $("#UsedCoinsMob").html(UsedCoins);
                }
            })
            .catch(err => {

            });
    }

    function PlaceAB2Bet() {
        const matchMinAmount = parseFloat(document.getElementById("MatchMinAmount").value);
        const matchMaxAmount = parseFloat(document.getElementById("MatchMaxAmount").value);
        const notificationType = "Match Bet";
        let response = "";

        const windowWidth = window.innerWidth;
        let betAmount = windowWidth >= 500
            ? parseFloat(document.getElementById("MatchAmount").value)
            : parseFloat(document.getElementById("MatchAmountMob").value);

        if (windowWidth >= 500) {
            document.getElementById("cmdDone").disabled = true;
        } else {
            document.getElementById("cmdDoneMob").disabled = true;
        }

        const modal = document.getElementById("myModal");
        if (modal) modal.style.display = "none"; // Hide the modal

        if (!isNaN(betAmount)) {
            if (betAmount >= matchMinAmount && betAmount <= matchMaxAmount) {
                const betRate = document.getElementById("MatchRate").value;
                const betMode = document.getElementById("MatchBetChk").value;
                const betTeam = document.getElementById("MatchTeam").value;
                const matchCode = document.getElementById("RoundID").innerHTML;
                const matchBetChk = document.getElementById("MatchBetChk").value;
                const matchType = "Lucky7";
                const userType = document.getElementById("UserType").value;
                const userName = document.getElementById("UserName").value;

                const teamKRate = document.getElementById("TeamKRate").value;
                const teamLRate = document.getElementById("TeamLRate").value;
                const bst = document.getElementById("ServerTime_Select").value;
                const bpt = document.getElementById("ServerTime_Formatted").value;
                const id = document.getElementById("BetTeamindex").value;

                console.log("id="+id+", TeamKRate="+$("#TeamKRate").val()+", MatchRate="+$("#MatchRate").val());
				
				if(($("#TeamKRate").val()==$("#MatchRate").val()) && betMode!="") {
                    const url = `${API_DOMAIN}/PlaceAB2Bet.php?BetRate=${betRate}&BetAmount=${betAmount}&BetMode=${betMode}&BetTeam=${betTeam}&MatchCode=${matchCode}&MatchBetChk=${matchBetChk}&MatchType=${matchType}&BetType=${"Match Bet"}&TeamKRate=${teamKRate}&TeamLRate=${teamLRate}&BST=${bst}&BPT=${bpt}&ut=${userType}&un=${userName}`;

                    fetch(url, {
                        method: 'GET',
                        credentials: 'include', // Equivalent to withCredentials:true
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                        .then(response => response.json())
                        .then(data => {
                            if (data.Status === "Success") {
                                document.getElementById("TotalCoins").innerHTML = data.TotalCoins - data.UsedCoins;
                                document.getElementById("UsedCoins").innerHTML = data.UsedCoins;

                                document.getElementById("TotalCoinsMob").innerHTML = data.TotalCoins - data.UsedCoins;
                                document.getElementById("UsedCoinsMob").innerHTML = data.UsedCoins;

                                setTeam1Amt(data.Team1Amt);
                                setTeam2Amt(data.Team2Amt);

                                sessionStorage.setItem('Coins', data.TotalCoins);
                                sessionStorage.setItem('Exposure', data.UsedCoins);
                                
                                setAB2Bets((prevBets) => [data.BetDetails[0], ...prevBets]);

                                response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                                            <div class="message-content success">
                                                <i class="component-icon-wrap icon-success"></i>
                                                <p>Bet Successful</p>
                                            </div>
                                        </div>`;
                            } else {
                                response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                                            <div class="message-content error">
                                                <i class="component-icon-wrap icon-error"></i>
                                                <p>${data.Message}</p>
                                            </div>
                                        </div>`;
                            }
                            document.getElementById("BetResponse").innerHTML = response;
                            setTimeout(() => { document.getElementById("BetResponse").innerHTML = ""; }, 3000);
                            ;
                            $("#betSlipBoxSession").css('display', 'none');
                            $("#betSlipBoxSessionMob").css('display', 'none');
                        });
                } else {
                    response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                                <div class="message-content error">
                                    <i class="component-icon-wrap icon-error"></i>
                                    <p>Bet Rejected. Rate Has Been Changed</p>
                                </div>
                            </div>`;
                    document.getElementById("BetResponse").innerHTML = response;
                    $("#betSlipBoxSession").css('display', 'none');
                    $("#betSlipBoxSessionMob").css('display', 'none');
                    setTimeout(() => { document.getElementById("BetResponse").innerHTML = ""; }, 3000);
                    
                }
            } else {
                response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                            <div class="message-content error">
                                <i class="component-icon-wrap icon-error"></i>
                                <p>${betAmount < matchMinAmount ? `Minimum Bet Amount is ${matchMinAmount}` : `Maximum Bet Amount is ${matchMaxAmount}`}</p>
                            </div>
                        </div>`;
                document.getElementById("BetResponse").innerHTML = response;
                $("#betSlipBoxSession").css('display', 'none');
                $("#betSlipBoxSessionMob").css('display', 'none');
                setTimeout(() => { document.getElementById("BetResponse").innerHTML = ""; }, 3000);
            }
        } else {
            response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                        <div class="message-content error">
                            <i class="component-icon-wrap icon-error"></i>
                            <p>Invalid Amount ${betAmount}</p>
                        </div>
                    </div>`;
            document.getElementById("BetResponse").innerHTML = response;
            $("#betSlipBoxSession").css('display', 'none');
            $("#betSlipBoxSessionMob").css('display', 'none');
            setTimeout(() => { document.getElementById("BetResponse").innerHTML = ""; }, 3000);
        }
    }

    $(document).on('click', '.casinoBet', function (e) {
        //fadeOutReset();
        console.log("BetChk=" + BetChk);
        if (BetChk == true) {
            var rateVal = $(this).attr('rt');
            var betOn = $(this).attr('betOn');
            var gameId = $("#market_id").val();
            var betType = $(this).attr('bt');

            console.log("rateVal=" + rateVal + ", betType=" + betType + ", betOn=" + betOn);

            var player = "";
            var betTypeText = "";

            if (rateVal > 0) {

                if (betOn == 1) {
                    player = "Andar";
                } else if (betOn == 3) {
                    player = "Bahar";
                }

                $("#BetTeamindex").val($(this).attr('sr'));
                $("#MatchTeam").val(player);
                $("#MatchBetChk").val("K");
                $("#MatchRate").val(rateVal);

                $("#DisplayBhavName").html(player);
                $("#Rate1_Odds").val(rateVal);

                //console.log("KRate="+$("#KRate"+betOn).attr("rt"));
                $("#TeamKRate").val(rateVal);
			    $("#TeamLRate").val(0);
                $("#ServerTime_Select").val($("#ServerTime_Formatted").val());

                $("#modalTitle").html("LUCKY 7A - " + player);
                $("#modalRate").html(rateVal);
                $("#betOnModal").val(betOn);
                $("#betTypeModal").val(betType);
                $("#rateValModal").val(rateVal);
                $("#gameId").val(gameId);

                //console.log("rateVal=" + rateVal + ", betOn=" + betOn + ", betType=" + betType + ", player=" + player)
                var $window = $(window);
                var windowsize = $window.width();
                //console.log(windowsize);
                if (windowsize >= 500) {
                    console.log("Lap");
                    $("#betSlipBoxSession").css('display', 'block');
                    $("#DisplayBhavName").html(player);
                    $("#Rate1_Odds").val(rateVal);
                    document.getElementById("cmdDone").disabled = false;
                    // document.getElementById("cmdDone").style.visibility = "visible";
                    document.getElementById("MatchAmount").value = "";
                    document.getElementById("MatchAmount").readOnly = false;
                    $("#betBoxColor").css('background-color', 'rgb(250, 169, 186)');
                } else {
                    console.log("Mob");
                    $("#betSlipBoxSessionMob").css('display', 'block');
                    $("#DisplayBhavNameMob").html(player);
                    $("#Rate1_OddsMob").val(rateVal);
                    document.getElementById("cmdDoneMob").disabled = false;
                    // document.getElementById("cmdDoneMob").style.visibility = "visible";
                    document.getElementById("MatchAmountMob").value = "";
                    document.getElementById("MatchAmountMob").readOnly = false;
                    $("#betBoxColorMob").css('background-color', 'rgb(250, 169, 186)');
                }
            }
        }
    });

    var ClearTable = true;
    var DisplayResult = false;
    var MarketID_Old="";
    var BASE_URL = "";

    var OpenBet = true;
    var FirstBet = false;
    var ThirdBet = false;

    function getBhavData() {

        var card1 = '';
        var card2 = '';
        var card3 = '';
        var count = 0;
        var imgURL = '';

        $.get(`${API_DOMAIN}/api/odds/Casino/AB2.php`, function (data) {

            var ServerTime = "";

            var t = data.ServerTime.split(/[- :]/);
            var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
            ServerTime = Date.parse(d);

            var myDate = d;
            var ServerTime_Formatted = myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + ('0' + myDate.getDate()).slice(-2) + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + myDate.getSeconds();
            $("#ServerTime_Formatted").val(ServerTime_Formatted);

            var card1 = '';

            data = (data.AB2Data);
            //console.log(data);
            if (data.success == true) {
                if(data.data.t1 ) {
                    var datas = data.data.t1[0];

                    var timer = datas.autotime;
                    var timer1 = 0;
                    var timer2 = 0;

                    //setCountDown(datas.autotime);

                    //console.log(timer);
                    $("#RoundID").html(datas.mid);

                    if (timer.length == 1) {
                        timer1 = 0;
                        timer2 = timer[0];
                    } else if (timer.length == 2) {
                        timer1 = timer[0];
                        timer2 = timer[1];
                    }

                    card1 = '';
                    card2 = '';
                    card3 = '';

                    if (datas.C1 == '1') {
                        imgURL = BASE_URL + "/cards/1.png";
                        OpenBet = true;
                    } else {
                        imgURL = BASE_URL + "/cards/" + datas.C1 + ".png";
                        OpenBet = false;
                    }

                    var imgURL1 = '', imgURL2 = '', imgURL3 = '';

                    console.log("Cards.length=" + datas.Cards.length);

                    $.each(datas.Cards.split(','), function (k, v) {

                        if (k == 0) {
                            if (v != '1') {
                                imgURL1 = BASE_URL + "/cards/" + v + ".png";
                            } else {
                                imgURL1 = BASE_URL + "/cards/1.png";
                            }
                        }

                        if (k > 0) {
                            if (k == 1) {
                                if (v == '1')
                                    FirstBet = true;
                                else
                                    FirstBet = false;
                            }

                            if (k == 3) {
                                if (v == '1')
                                    ThirdBet = true;
                                else
                                    ThirdBet = false;
                            }

                            if (k % 2 != 0) {
                                if (v != '1') {
                                    imgURL3 = BASE_URL + "/cards/" + v + ".png";
                                    card3 += '<img src="' + imgURL3 + '" class="andar-bahar-image"/>';
                                }
                            } else {
                                if (v != '1') {
                                    imgURL2 = BASE_URL + "/cards/" + v + ".png";
                                    card2 += '<img src="' + imgURL2 + '" class="andar-bahar-image" />';
                                }
                            }
                        }

                    });

                    card1 += '<img src="' + imgURL1 + '" class="ab2-res-fst-card" />';

                    $("#cards_player1").html(card1);
                    $("#cards_player2").html(card2);
                    $("#cards_player3").html(card3);

                    $("#Timer").html(timer);

                    if (timer > 3) {
                        $("#KRate1").val("0.95");
                        $("#KRate2").val("0.95");

                        $("#KRate1").attr("rt", "0.95");
                        $("#KRate2").attr("rt", "0.95");

                        $("#P1").attr("rt", "0.95");
                        $("#P2").attr("rt", "0.95");

                        $("#AndarLock").css("display", "none");
                        $("#BaharLock").css("display", "none");

                        setBetChk(true);

                    } else {
                        $("#KRate1").val("0.00");
                        $("#KRate2").val("0.00");

                        $("#KRate1").attr("rt", "0.00");
                        $("#KRate2").attr("rt", "0.00");

                        $("#P1").attr("rt", "0.00");
                        $("#P2").attr("rt", "0.00");

                        $("#AndarLock").css("display", "flex");
                        $("#BaharLock").css("display", "flex");

                        setBetChk(false);

                        //~ $("#KRate1").val("0.95");
                        //~ $("#KRate2").val("0.95");

                        //~ $("#KRate1").attr("rt","0.95");
                        //~ $("#KRate2").attr("rt","0.95");

                        //~ $("#P1").attr("rt","0.95");
                        //~ $("#P2").attr("rt","0.95");
                    }

                    if (datas.mid != MarketID_Old && ClearTable == true) {
                        DisplayResult = true;
                        MarketID_Old=$("#RoundID").html();
                        setAB2Bets([]);
                        setTeam1Amt("");
                        setTeam2Amt("");
                        ClearTable = true;
                    }
                    //console.log("RoundID="+$("#RoundID").html()+", ClearTable="+ClearTable+", DisplayResult="+DisplayResult);

                    if (DisplayResult == true) {
                        DisplayResult = false;
                        setTimeout(function () {
                            getAB2Result();
                        }, 7000);                        
                    }

                    if(MarketID_Old!=datas.mid)
                        MarketID_Old=datas.mid;
                }
                
            } else {
                console.log("False");
            }
        });

    }

    useEffect(() => {
        //setLastResult([]);

        setUserType(sessionStorage.getItem("UserType"));
        setUserName(sessionStorage.getItem("UserName"));

        getAB2Result();

        const marketOdsCall = setInterval(() => {
            getBhavData();
        }, 1000);

        return () => clearInterval(marketOdsCall);

    }, []);

    return (
        <>
            <section className="match-content">

                <div className="">
                    <div className="match-box" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>
                        <div className="mod-header">
                            <div className="select-tv-ico">
                                <span>Andar Bahar 2 </span>
                                <span style={{ float: 'right' }}>RoundId : <span id="RoundID"></span></span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="col-12 col-md-12" style={{ padding: '0px' }}>
                            <iframe className="live-str" src="https://apis.professorji.in/api/casino-streaming/3043" height="400" width="100%" style={{ backgroundColor: 'black' }}></iframe>
                            <button className="rules-btn">
                                <img style={{ width: '20px' }} src="/images/info.png" />
                            </button>
                            <div className="flipclock">
                                <span className="flipclock-t1 fold" id="Timer">0 0</span>
                            </div>
                            <div className="res-box">
                                <span id="cards_player1" style={{ float: 'right' }}></span>
                                <div className="col-md-12 col-12 andr-bhar2-res-text andarbahar-res" id="divCard2">
                                    Andar
                                    <span className="next-card-res">
                                        <img src="/cards/right-arrow.png" style={{ height: '15px' }} />
                                    </span>
                                    <span className="perv-card-res">
                                        <img src="/cards/left-arrow.png" style={{ height: '15px' }} />
                                    </span>
                                    <div className="rescard andar andar1" id="cards_player2">

                                    </div>
                                </div>
                                <div className="col-md-12 col-12 andr-bhar2-res-text andarbahar-res" id="divCard3">Bahar <span className="next-card-res">
                                    <img src="/cards/right-arrow.png" style={{ height: '15px' }} />
                                </span>
                                    <span className="perv-card-res">
                                        <img src="/cards/left-arrow.png" style={{ height: '15px' }} />
                                    </span>
                                    <div className="rescard  bahar bahar1" id="cards_player3">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mr-left-right lucky7-main" style={{ justifyContent: 'center' }}>
                        <div style={{ textAlign: 'center' }} className="col-12 col-sm-2 col-md-2">
                            <div className="ab2-text" style={{ color: 'rgb(0, 0, 0)', fontWeight: '700' }}>Andar</div>
                        </div>
                        <div className="col-10 col-sm-2 col-md-2">
                            <div className="col-12 ab2-text ab2-btn-background casinoBet" style={{ padding: '0px' }} rt="0.95" betOn="1" bt="1" id="P1" sr="1">1st Bet <span>0.95</span>
                                <div className="susb-bhav" id="AndarLock">
                                    <img src="/cards/padlock.png" />
                                </div>
                            </div>
                             <div style={{ color: `${Team1Amt >=0 ? "green" : "red"}` }} >{Team1Amt} </div>
                        </div>
                        {/* <div className="col-3 col-sm-3 col-md-3">
                            <div className="col-12 ab2-text ab2-btn-background" style={{padding: '0px'}}>2nd Bet <span>0.95</span>
                                <div className="susb-bhav" ng-if="Timer<4 || FirstBet==false">
                                    <img src="/cards/padlock.png"/>
                                </div>
                            </div>
                            <div style={{color: 'red'}}>0 </div>
                        </div>
                        <div className="col-3 col-sm-3 col-md-3">
                            <div className="col-12 ab2-text ab2-btn-background" style={{padding: '0px'}}>3rd Bet <span>0.95</span>
                                <div className="susb-bhav">
                                    <img src="/cards/padlock.png"/>
                                </div>
                            </div>
                            <div style={{color: 'red'}}>0 </div>
                        </div> */}
                        <div style={{ textAlign: 'center' }} className="col-12 col-sm-2 col-md-2">
                            <div className="ab2-text" style={{ color: 'rgb(0, 0, 0)', fontWeight: '700' }}>Bahar</div>
                        </div>
                        <div className="col-10 col-sm-2 col-md-2">
                            <div className="col-12 ab2-text ab2-btn-background casinoBet" style={{ padding: '0px' }} rt="0.95" betOn="3" bt="1" id="P2" sr="3">1st Bet <span>0.95</span>
                                <div className="susb-bhav" id="BaharLock">
                                    <img src="/cards/padlock.png" />
                                </div>
                            </div>
                            <div style={{ color: `${Team2Amt >=0 ? "green" : "red"}` }} >{Team2Amt} </div>
                        </div>
                        {/* <div className="col-3 col-sm-3 col-md-3">
                            <div className="col-12 ab2-text ab2-btn-background" style={{padding: '0px'}}>2nd Bet <span>0.95</span>
                                <div className="susb-bhav" ng-if="Timer<4 || FirstBet==false">
                                    <img src="/cards/padlock.png"/>
                                </div>
                            </div>
                            <div style={{color: 'red'}}>0 </div>
                        </div>
                        <div className="col-3 col-sm-3 col-md-3">
                            <div className="col-12 ab2-text ab2-btn-background" style={{padding: '0px'}}>3rd Bet <span>0.95</span>
                                <div className="susb-bhav">
                                    <img src="/cards/padlock.png"/>
                                </div>
                            </div>
                            <div style={{color: 'red'}}>0 </div>
                        </div> */}
                    </div>
                    <div style={{ marginLeft: '0px', marginRight: '0px' }}>
                        <div className="table_tittle" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>
                            <div className="">
                                <div className="select-tv-ico">
                                    <span>Last Result</span>
                                    <span style={{ float: 'right' }}>
                                        <Link style={{ color: 'rgb(255, 255, 255)' }} to="/Dashboard/AB2Result">View All</Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="Result" style={{ color: 'white', backgroundColor: 'rgb(255, 255, 255)', textAlign: 'right', width: '100%' }}>
                            <div>
                                {LastResult.map((row, index) => (
                                    <span
                                        key={index}
                                        className={`game-result ${row.WonBy == 'ANDAR' ? 'bg-primary' : 'bg-dark'}`}
                                    >
                                        {row.WonBy == 'ANDAR' ? 'A' : 'B'}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <input name="MatchCode" type="hidden" id="MatchCode" />
                <input name="MatchRate" type="hidden" id="MatchRate" />
                <input name="MatchTeam" type="hidden" id="MatchTeam" />

                <input name="ServerTime_Select" type="hidden" id="ServerTime_Select" />
                <input name="ServerTime_Submit" type="hidden" id="ServerTime_Submit" />

                <input name="DateTimeP" type="hidden" id="DateTimeP" value="1572429898000" />
                <input name="ServerTime_Formatted" type="hidden" id="ServerTime_Formatted" />

                <input name="TeamKRate" type="hidden" id="TeamKRate" />
                <input name="TeamLRate" type="hidden" id="TeamLRate" />
                <input name="BetTeamindex" type="hidden" id="BetTeamindex" />

                <input name="SubmitTimeValue" type="hidden" id="SubmitTimeValue" value="" />

                <input name="MatchBetChk" type="hidden" id="MatchBetChk" value="" />
                <input name="SessionBetChk" type="hidden" id="SessionBetChk" value="" />

                <input name="UserType" id="UserType" type="hidden" value={UserType} />
                <input name="UserName" id="UserName" type="hidden" value={UserName} />

                <input name="MatchMinAmount" type="hidden" id="MatchMinAmount" value="100" />
                <input name="MatchMaxAmount" type="hidden" id="MatchMaxAmount" value="10000" />

                <input name="AmountTime" type="hidden" id="AmountTime" value="" />
                <input name="AmountTimeChk" type="hidden" id="AmountTimeChk" value="" />

                <div className="right-bet-inner">
                    <div id="MatchUnMatchBetaData">
                        <div id="accountView" role="main">
                            <span id="msg_error"></span>
                            <span id="errmsg"></span>
                            <div className="balance-panel-body">
                                <div className="table-responsive sports-tabel">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr className="heading_user_table" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>
                                                <td>Team</td>
                                                <td>Mode</td>
                                                <td>Rate</td>
                                                <td>Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {AB2Bets.map((row, index) => (
                                                <tr className="heading_user_table">
                                                    <td>{row.Team}</td>
                                                    <td>{row.Mode === "K" ? "L" : "K"}</td>
                                                    <td>{row.Rate}</td>
                                                    <td>{row.Amount}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <div id="betSidenav" className="betsidenav">
                <a className="closebtn">x</a>
                <section className="right-bet-content">
                    <div className="betSlipBox" id="betSlipBoxSession" style={{ display: 'none' }}>
                        <div className="betBox bet-slip-box">
                            <span id="msg_error"></span>
                            <span id="errmsg"></span>
                            <div className="lds-dual-ring  loader" style={{ display: 'none' }}></div>
                            <div className="bet-box_inner" id="betBoxColor" style={{ backgroundColor: 'rgb(250, 169, 186)' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', margin: '5px', alignItems: 'center' }}>
                                    <div style={{ fontWeight: '700' }} id="DisplayBhavName"></div>
                                </div>
                                <div className="inner-bet-section">
                                    <div className="oddds-stake-box" style={{ marginBottom: '10px' }}>
                                        <div className="items odds">
                                            <div className="stack_input_field numbers-row">
                                                <input disabled="" type="number" className="calProfitLoss odds-input form-control  CommanBtn" value="" id="Rate1_Odds" />
                                                <div className="inc plus_btn">
                                                    <span className="plus_btns">+</span>
                                                    <div className="quantity-button quantity-up">
                                                        <i className="fas fa-plus"></i>
                                                    </div>
                                                </div>
                                                <div className="dec plus_btn">
                                                    <span className="minus_btns">-</span>
                                                    <div className="quantity-button quantity-down">
                                                        <i className="fas fa-minus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="items stake" id=" ">
                                            <div className="stack_input_field numbers-row">
                                                <input type="number" pattern="[0-9]*" step="1" id="MatchAmount" className="calProfitLoss stake-input form-control  CommanBtn" value="0" />

                                                <div className="inc plus_btn">
                                                    <span className="plus_btns">+</span>
                                                    <div className="quantity-button quantity-up">
                                                        <i className="fas fa-plus"></i>
                                                    </div>
                                                </div>
                                                <div className="dec plus_btn">
                                                    <span className="minus_btns">-</span>
                                                    <div className="quantity-button quantity-down">
                                                        <i className="fas fa-minus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bet-btns">
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="100" onClick={() => { document.getElementById("MatchAmount").value = 100; }}>100</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="200" onClick={() => { document.getElementById("MatchAmount").value = 200; }}>200</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="500" onClick={() => { document.getElementById("MatchAmount").value = 500; }}>500</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="1000" onClick={() => { document.getElementById("MatchAmount").value = 1000; }}>1K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="2000" onClick={() => { document.getElementById("MatchAmount").value = 2000; }}>2K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="3000" onClick={() => { document.getElementById("MatchAmount").value = 3000; }}>3K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="5000" onClick={() => { document.getElementById("MatchAmount").value = 5000; }}>5K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="10000" onClick={() => { document.getElementById("MatchAmount").value = 10000; }}>10K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" " type="button">Clear</button>
                                        </div>
                                    </div>
                                    <div className="bet-box-footer">
                                        <button className="btn cancle-bet" type="button" onClick={handleCancelClick}>Cancel</button>
                                        <button className="btn place-bet" type="button" id="cmdDone" onClick={handlePlaceBet}>Place Bet</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="overlay_mobile in"></div>

                </section>
            </div>

            <div className="betSlipBox mobile-bet-box" style={{position: 'fixed', bottom: '0px', zIndex: '999',display:'none'}} id="betSlipBoxSessionMob">
                <div className="betBox bet-slip-box">
                    <span id="msg_error"></span>
                    <span id="errmsg"></span>
                    <div className="lds-dual-ring  loader" style={{display: 'none'}}></div>
                    <div className="bet-box_inner bet-box-inner-mobile" id="betBoxColorMob" style={{backgroundColor: 'rgb(250, 169, 186)'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', padding: '10px', margin: '5px', alignItems: 'center'}}>
                            <div style={{fontWeight: '700'}} id="DisplayBhavNameMob">45 over run SA</div>
                        </div>
                        <div className="inner-bet-section">
                            <div className="oddds-stake-box" style={{marginBottom: '10px'}}>
                                <div className="items odds">
                                    <div className="stack_input_field numbers-row">
                                        <input type="number" pattern="[0-9]*" disabled="" className="calProfitLoss odds-input form-control  CommanBtn" value="188" id="Rate1_OddsMob"/>
                                    </div>
                                </div>
                                <div className="items stake">
                                    <div className="stack_input_field numbers-row">
                                        <input type="number" pattern="[0-9]*" step="1" id="MatchAmountMob" className="calProfitLoss stake-input form-control  CommanBtn"/>
                                        <div className="inc plus_btn">
                                            <span className="plus_btns">+</span>
                                            <div className="quantity-button quantity-up">
                                                <i className="fas fa-plus"></i>
                                            </div>
                                        </div>
                                        <div className="dec plus_btn">
                                            <span className="minus_btns">-</span>
                                            <div className="quantity-button quantity-down">
                                                <i className="fas fa-minus"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bet-btns">
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="100" onClick={() => { document.getElementById("MatchAmountMob").value =100; }}>100</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="200" onClick={() => { document.getElementById("MatchAmountMob").value =200; }}>200</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="500" onClick={() => { document.getElementById("MatchAmountMob").value =500; }}>500</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="1000" onClick={() => { document.getElementById("MatchAmountMob").value =1000; }}>1K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="2000" onClick={() => { document.getElementById("MatchAmountMob").value =2000; }}>2K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="3000" onClick={() => { document.getElementById("MatchAmountMob").value =3000; }}>3K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="5000" onClick={() => { document.getElementById("MatchAmountMob").value =5000; }}>5K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="10000" onClick={() => { document.getElementById("MatchAmountMob").value =10000; }}>10K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="20000" onClick={() => { document.getElementById("MatchAmountMob").value =20000; }}>20K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="25000" onClick={() => { document.getElementById("MatchAmountMob").value =25000; }}>25K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="50000" onClick={() => { document.getElementById("MatchAmountMob").value =50000; }}>50K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" " type="button">Clear</button>
                                </div>
                            </div>
                            <div className="bet-box-footer">
                                <button className="btn cancle-bet" type="button" onClick={handleCancelClick}>Cancel</button>
                                <button className="btn place-bet" type="button" id="cmdDoneMob" onClick={handlePlaceBet}>Place Bet</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AB2;
